import * as Tooltip from "@radix-ui/react-tooltip";
import { motion } from "motion/react";
import clsx from "clsx";
import { keyCodeLabel } from "@/shared/constants/keyCodeLabel";
import { RefreshIcon } from "@/shared/icons";
import { SoundButton } from "@/shared/ui";

type Props = {
  description: string;
  keyboardBindType: number;
  keyCode?: number;
  onClick: (keyboardBindType: number) => void;
  onReset: (keyboardBindType: number) => void;
  isResetting: boolean;
};

export default function PlayerMenuSettingsControlBind({
  keyboardBindType,
  keyCode,
  description,
  onClick,
  onReset,
  isResetting,
}: Props) {
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
        <div
          className={clsx(
            "w-full flex items-center gap-3 h-[3.125rem] px-3.5 transition-all",
            "border border-dark-700 rounded-[0.5rem]",
            "bg-dark-800 hover:bg-gradient-to-r from-accent-muted/30 to-transparent",
            "hover:border-accent-muted/30",
          )}
          onClick={() => {
            onClick(keyboardBindType);
          }}
        >
          <div
            className={clsx(
              "h-[1.25rem] w-fit min-w-[1.25rem] px-1 flex items-center justify-center rounded-[0.325rem]",
              "text-14 leading-3 font-bold shrink-0",
              {
                "text-dark-900 bg-white uppercase": keyCode,
                "text-white/30 bg-dark-800": !keyCode,
              },
            )}
          >
            {keyCode ? keyCodeLabel[keyCode] : "-"}
          </div>

          <div className="text-14 font-bold">{description}</div>

          <Tooltip.Trigger asChild>
            <SoundButton
              className="h-[2.25rem] aspect-square shrink-0 ml-auto p-0"
              color="gray"
              variant="soft"
              onClick={(e) => {
                e.stopPropagation();
                onReset(keyboardBindType);
              }}
              disabled={isResetting}
            >
              <motion.div
                animate={{ rotate: isResetting ? 360 : 0 }}
                transition={
                  isResetting
                    ? { repeat: Infinity, duration: 1, ease: "linear" }
                    : { duration: 0.3 }
                }
              >
                <RefreshIcon size={18} className="text-white/50 shrink-0" />
              </motion.div>
            </SoundButton>
          </Tooltip.Trigger>
          <Tooltip.Portal>
            <Tooltip.Content
              className="z-50 w-fit bg-dark-800 px-4 py-2 rounded-[0.5rem] text-12 shadow-lg animate-fade-in"
              sideOffset={5}
              side="top"
              align="center"
            >
              Сбросить по дефолту
            </Tooltip.Content>
          </Tooltip.Portal>
        </div>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
